class Loader {
    constructor(resources, callback) {
        this.resources = resources;
        this.loaded_r = 0;
        this.percentage = 0;
        this.callback = callback;
    }
    start() {
        for (let res of this.resources) {
            let img = new Image();
            img.onload = this.loaded.bind(this);
            img.onerror = this.error.bind(this);
            img.src = res;
        }
    }
    loaded(img) {
        // console.log(this.loaded_r);
        this.loaded_r += 1;
        this.percentage = this.loaded_r / this.resources.length;
        if (this.callback) {
            this.callback(this.percentage);
        }

    }
    error(img) {
        console.log("ERRORE", img.path[0].src);
        this.loaded(img);
    }
}

export default Loader;